<template>
    <div>
        <div class="table-wrapper">
            <div class="query-box">
                <Form ref="formInline" :model="formInline"  inline :label-width="150" >
                    <div class="search-right-wrapper">
                        <Button :loading="eLoading" type="primary" style="float:left;" icon="ios-exit-outline" @click="handleExport">导出</Button>

                        <FormItem label="系统供应商名称:" prop="supplierName">
                            <Input v-model="formInline.supplierName" placeholder="请输入系统供应商名称"></Input>
                        </FormItem>
                        <Button style="float: right;" type="primary" @click="handleQuery">查询</Button>
                    </div>
                </Form>
            </div>
            <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" type="text" size="small" @click="handleDeal('suppierManagementDeatils',row)" style="margin-right: 12px;">详情</span>
                </template>
            </Table>
            <div class="t-page">
                <Page :total="totalCount" :page-size="pageSize" :current="page"
                      @on-change="changePage" @on-page-size-change="pageSizeChange"
                      show-elevator show-sizer show-total transfer>
                </Page>
            </div>
        </div>
    </div>
</template>

<script>
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                formInline:{
                    areaCode: localStorage.getItem('tenantAreaCode'),
                    supplierName :'',
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '系统供应商名称',
                        key: 'supplierName',
                        align: 'left',
                    },
                    {
                        title: '项目数',
                        key: 'supplierNum',
                        align: 'left',
                    },
                    {
                        title: '项目占比',
                        key: 'supplierRate',
                        align: 'left',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 150
                    }
                ],
                tableData:[],
            };
        },
        computed:{
        },
        created(){

        },
        mounted(){
        },
        watch: {
            '$route': function (to, from) {

            },
        },
        methods: {
            //导出
            handleExport(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                Object.assign(param,this.formInline);
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/supplier/supplierExport',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'供应商管理列表.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            changePage(val) {
                this.page = val
                this.getTableData()
            },
            pageSizeChange(val) {
                this.pageSize = val
                this.getTableData()
            },
            /*点击详情操作*/
            handleDeal(name,row){
                this.$router.push({
                    name: name,
                    query: {
                        supplierName:row.supplierName
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                Object.assign(param,this.formInline);
                this.tableData=[];
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/supplier/pageList',
                    data:param,
                }).then( (response)=> {
                    this.loading=false;
                    if(response.data){
                        this.totalCount = response.data.data.total;
                        this.tableData=response.data.data.records;
                    }

                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
